export default "__VITE_ASSET__DipYJxLD__"